import React, { useState } from 'react';
import { Table, Upload, Button, message, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Papa from 'papaparse';

const { Title } = Typography;

const columns = [
  { title: 'Date', dataIndex: 'date', key: 'date' },
  { title: 'Description', dataIndex: 'description', key: 'description' },
  { title: 'Amount', dataIndex: 'amount', key: 'amount' },
  { title: 'Type', dataIndex: 'type', key: 'type' },
  { title: 'Balance', dataIndex: 'balance', key: 'balance' },
];

const BankImportTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleUpload = (info) => {
    if (info.file.status !== 'uploading') {
      setLoading(true);
      Papa.parse(info.file.originFileObj, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          setData(results.data);
          setLoading(false);
          message.success('File imported successfully!');
          // Dummy backend call
          setTimeout(() => message.info('Pretend backend API called!'), 500);
        },
        error: () => {
          setLoading(false);
          message.error('Failed to parse file.');
        }
      });
    }
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <Title level={3}>Import Bank Statement / Spreadsheet</Title>
      <Upload
        accept=".csv,.xlsx,.xls"
        showUploadList={false}
        customRequest={({ file, onSuccess }) => setTimeout(() => onSuccess('ok'), 0)}
        onChange={handleUpload}
      >
        <Button icon={<UploadOutlined />}>Click to Import Spreadsheet</Button>
      </Upload>
      <Table
        columns={columns}
        dataSource={data.map((row, idx) => ({ ...row, key: idx }))}
        loading={loading}
        style={{ marginTop: 24 }}
        pagination={false}
      />
    </div>
  );
};

export default BankImportTable;
